import { get } from "lodash";
import { AT_TYPES_TO_KEYS } from "../../constants/entity.js";
import { ICON_MAP } from "../../constants/iconMap.js";

// -- HELPERS -- //

export function generateSimpleResourceMap(queryResult) {
  return queryResult.map(item => {
    return {
      key: item.id,
      value: item["@id"],
      service: item.services,
      text: item.name,
      readOnly: item.readonly,
      icon: ICON_MAP[item.operatingSystem]
    };
  }, []);
}

// -- PROPS QUERIES -- //

export const getAtIdFromMatchProps = (props, type) => {
  const id = get(props, "match.params.id", null);
  type = type || get(props, "match.params.type", null);

  if (!id || !type) return null;

  return `/${type}/${id}`;
};

export const regionIdFromPropsData = (state, props) => {
  return get(props, "data.region.@id", undefined);
};

export const typeFromPropsData = (state, props) => {
  return get(props, "data.@type", undefined);
};

export const typeKeyFromPropsData = (state, props) => {
  const atType = get(props, "data.@type", undefined);
  return AT_TYPES_TO_KEYS[atType] || null;
};

export const typeKeyFromResourceTypePropQuery = (state, props) => {
  if (props.resourceType) return AT_TYPES_TO_KEYS[props.resourceType];
  // console.warn(
  //   "projectWizardSelectors: typeKeyFromResourceTypePropQuery will always return null if props.resourceType is not set"
  // );
  return null;
};

// using the following export pattern so we can mock more easily using jest

const selectorUtils = {
  generateSimpleResourceMap,
  getAtIdFromMatchProps,
  regionIdFromPropsData,
  typeKeyFromPropsData,
  typeKeyFromResourceTypePropQuery
};

export default selectorUtils;
